(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .component("editExam", {
        templateUrl: "app/exams/editExam.component.html",
        controller: ["examResource", "messageService", "$localStorage", "$state", EditExamCtrl],
        controllerAs: "vm"
    });
    function EditExamCtrl(examResource, messageService, $localStorage, $state) {
        var vm = this;
        vm.showErrors = false;
        vm.loading = true;
        vm.number = $state.params.number;
        vm.enabledLocalizations = $localStorage.tenantSettings.enabledLocalizations;
        vm.currentState = $state.current.name;
        examResource.getByNumber({ number: vm.number }, function (model) {
            vm.formData = model;
            vm.examName = angular.copy(vm.formData.name);
            $localStorage.editExamName = vm.examName;
            vm.loading = false;
        }, function (errorData) {
            messageService.error(errorData);
        });
        vm.save = function (isValid) {
            if (isValid) {
                examResource.update({ number: vm.number }, vm.formData, function (result) {
                    vm.formData = result;
                    vm.examName = angular.copy(vm.formData.name);
                    messageService.success("exams.editExam.saved");
                }, function (errorData) {
                    messageService.error(errorData);
                });
            }
            else {
                vm.showErrors = true;
            }
        };
        vm.saveAndReturn = function (isValid) {
            if (isValid) {
                examResource.update({ number: vm.number }, vm.formData, function () {
                    messageService.success("exams.editExam.saved");
                    $state.go("main.learningItems.manageExams");
                }, function (errorData) {
                    messageService.error(errorData);
                });
            }
            else {
                vm.showErrors = true;
            }
        };
    }
}());
